import { Routes } from '@angular/router';
import { TeamOwnerDetailsPage } from './page/teamlid-details-page/team-owner-details.page';
import { TeamlidDetailsEditPage } from './page/teamlid-details-edit/teamlid-details-edit.page';
import { TeamJongerePage } from './page/team-page-jongere/team-jongere.page';
import { UitnodigingDetailsPage } from './page/uitnodiging-details-page/uitnodiging-details.page';
import { TeamTeamlidPage } from './page/team-page-teamlid/team-teamlid.page';
import { TeamlidDetailsPage } from './page/team-owner-details-page/teamlid-details.page';
import {
  actiefAlsJongereMatcher,
  actiefAlsTeamlidMatcher,
  actiefVoorMezelfMatcher,
} from '../core/matchers';
import { TeamNoTeamPage } from './page/team-page-no-team/team-no-team.page';
import { GeblokkeerdTeamPage } from './page/geblokkeerd-team-page/geblokkeerd-team.page';
import { teamAddRoutes } from './team-add/team-add-routing';

export const teamRoutes: Routes = [
  {
    path: '',
    title: 'Team',
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'team.team-page.title',
        component: TeamJongerePage,
        canMatch: [actiefAlsJongereMatcher],
      },
      {
        path: '',
        pathMatch: 'full',
        component: TeamTeamlidPage,
        canMatch: [actiefAlsTeamlidMatcher],
      },
      {
        path: '',
        pathMatch: 'full',
        title: 'team.team-no-team-page.title',
        component: TeamNoTeamPage,
        canMatch: [actiefVoorMezelfMatcher],
      },
      {
        path: 'add',
        children: teamAddRoutes,
      },
      {
        path: 'geblokkeerd/:jongereId',
        component: GeblokkeerdTeamPage,
      },
      {
        path: 'details/eigenaar',
        component: TeamOwnerDetailsPage,
      },
      {
        path: 'details/:teamlidId',
        pathMatch: 'full',
        component: TeamlidDetailsPage,
      },
      {
        path: 'uitnodiging/:uitnodigingId',
        pathMatch: 'full',
        component: UitnodigingDetailsPage,
        title: 'team.uitnodiging-detail-page.title',
      },
      {
        path: 'details/:teamlidId/wijzig',
        pathMatch: 'full',
        component: TeamlidDetailsEditPage,
      },
    ],
  },
];
